import { useMap } from 'react-leaflet';
import { useEffect } from 'react';

// Enable/disable all map interactions dynamically; used for filter, calendar, and tour overlays
// to prevent the user from interacting with the map behind them

function MapInteraction({ disableMapInteractions }) {

  const map = useMap();

  useEffect(() => {
    if (!map) return;

    if (disableMapInteractions) {

        // Disable all common interactions
        map.dragging.disable();
        map.scrollWheelZoom.disable();
        map.doubleClickZoom.disable();
        map.boxZoom.disable();

        // Mobile-specific interaction
        if (map.tap) map.tap.disable();
    } else {

        // Re-enable all interactions
        map.dragging.enable();
        map.scrollWheelZoom.enable();
        map.doubleClickZoom.enable();
        map.boxZoom.enable();
        if (map.tap) map.tap.enable();
    }
  }, [disableMapInteractions, map]);

  return null;
}

export default MapInteraction;